import type { ClassStatus } from '@sophia/shared-schemas'
import { Badge } from '@/components/ui/Badge'

const map: Record<ClassStatus, { tone: 'neutral' | 'warning' | 'success'; label: string }> = {
  DRAFT: { tone: 'neutral', label: 'Rascunho' },
  TESTING: { tone: 'warning', label: 'Em teste' },
  PRODUCTION: { tone: 'success', label: 'Produção' },
}

export function StatusBadge({ status }: { status: ClassStatus }) {
  const { tone, label } = map[status]
  return <Badge tone={tone}>{label}</Badge>
}
